<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Bank Transaction List</h5>
            <span class="modal-x-button" (click)="onCloseDialog()">
                <i class="fa fa-times" aria-hidden="true"></i>
            </span>
        </div>
        <div class="modal-body">
            <div *ngIf="htmlContent">
                Last Scanned At: <b>{{ data?.transaction_data?.latest_transaction_scanned_at | timezoneDate: 'YYYY-MM-DD HH:mm:ss' }} </b>
                <div class="mt-3" [innerHTML]="htmlContent"></div>
            </div>
            <div *ngIf="!htmlContent" class="text-center text-muted">
                <i class="fas fa-info-circle fa-2x mb-3"></i>
                <h5>No transactions found</h5>
                <p>There are no bank transactions available for this account.</p>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="onCloseDialog()"><i class="fas fa-ban"></i>Close</button>
        </div>
    </div>
</div>